export { parseErrorAndReturnPayload, parseErrorMessageArray, isMainPageIndex } from "../../middleware/Utils/ErrorUtils";

export const getPrettyErrorMessage = (error, intl = null) => {
    let message = "unknown";
    if (!error) {
        message = "We apologize... This action can't be done";
        if (intl) {
            message = intl.messages.errorMessageUnknown;
        }
    } else if (error.errorCode === 0 && error.errorMessage.toLowerCase() === "failed to fetch") {
        message = error.errorMessage
        if (intl) {
            message = intl.messages.errorMessageNetwork;
        }
    } else {
        message = error.errorMessage
    }

    return message;
}

export const getPaymentPrettyErrorMessage = (error, intl = null) => {
    let message = getPrettyErrorMessage(error, intl);
    if (error && intl) {
        if (error.errorCode?.toString().startsWith("403")) {
            switch (error.errorCode) {
                case 403322:
                case 403324:
                case 403328:
                case 403330:
                    message = intl.messages.errorMessagePaymentNoPaymentFound;
                    break;
                case 403425:
                case 403426:
                    message = intl.messages.errorMessagePaymentApplicationStateIncorrect;
                    break;
                case 403327:
                    message = intl.messages.errorMessagePaymentWrongOffer;
                    break;
                case 403329:
                    message = intl.messages.errorMessagePaymentExpired;
                    break;
                case 403331:
                    message = intl.messages.errorMessagePaymentNoCompanyName;
                    break;
                case 403332:
                    message = intl.messages.errorMessagePaymentNoVat;
                    break;
                case 403333:
                    message = intl.messages.errorMessagePaymentBillingMissingFields + " " + error.errorCode.errorDetailsData?.missingFields.join(",");
                    break;
                case 403619:
                    message = intl.messages.errorMessagePaymentCheckVat;
                    break;
                default:
                    message = intl.messages.errorMessagePaymentSomethingWrong;
                    break;
            }
        } else if (error.errorCode?.toString().startsWith("404")) {
            message = intl.messages.errorMessagePaymentNotFound;
        }
    }

    return message;
}

export const getAuthenticationtPrettyErrorMessage = (error, intl = null) => {
    let message = getPrettyErrorMessage(error, intl);
    if (error && intl) {
        if (error.errorCode?.toString().startsWith("401")) {
            switch (error.errorCode) {
                case 401501:
                    message = intl.messages.loginErrorMessageLocked;
                    break;
                default:
                    message = intl.messages.loginErrorMessage_401;
                    break;
            }
        } else {
            message = intl.messages.loginErrorMessage_generic;
        }
    }

    return message;
}
